import { FileFormat } from '../../../../../types';
import type { Value } from '../types';

const showReplaceLineBreaksBlacklist = [FileFormat.androidSdk, FileFormat.srt];
export const isReplaceLineBreaksHidden = (fileFormat: FileFormat) =>
    showReplaceLineBreaksBlacklist.includes(fileFormat);

export const isSwitchCompactHidden = (fileFormat: FileFormat) => fileFormat !== FileFormat.arb;

const showIncludeDescriptionBlacklist = [
    FileFormat.appleXliff,
    FileFormat.applePlist,
    FileFormat.androidSdk,
    FileFormat.angularXliff,
    FileFormat.yaml,
    FileFormat.yamlRuby,
    FileFormat.stf,
    FileFormat.reactNativeJs,
    FileFormat.json,
    FileFormat.jsObject,
    FileFormat.phpArray,
    FileFormat.phpLaravel,
    FileFormat.symfonyXliff,
    FileFormat.srt,
];

export const isIncludeDescriptionHidden = (fileFormat: FileFormat, switchCompact: boolean) =>
    showIncludeDescriptionBlacklist.includes(fileFormat) || (fileFormat === FileFormat.arb && switchCompact);

const showIncludeCommentsBlacklist = [
    FileFormat.appleXliff,
    FileFormat.applePlist,
    FileFormat.androidSdk,
    FileFormat.angularXliff,
    FileFormat.yaml,
    FileFormat.yamlRuby,
    FileFormat.stf,
    FileFormat.reactNativeJs,
    FileFormat.json,
    FileFormat.jsonStructured,
    FileFormat.jsObject,
    FileFormat.phpArray,
    FileFormat.phpLaravel,
    FileFormat.symfonyXliff,
    FileFormat.arb,
    FileFormat.srt,
];
export const isIncludeCommentsHidden = (fileFormat: FileFormat, switchCompact: boolean) =>
    showIncludeCommentsBlacklist.includes(fileFormat) || (fileFormat === FileFormat.arb && switchCompact);

const showAddNewLineAtEofWhitelist = [
    FileFormat.json,
    FileFormat.jsObject,
    FileFormat.phpArray,
    FileFormat.phpLaravel,
    FileFormat.reactNativeJs,
    FileFormat.arb,
    FileFormat.jsonStructured,
    FileFormat.appleStrings,
    FileFormat.appleStringsdict,
];
export const isAddNewLineAtEofHidden = (fileFormat: FileFormat) => !showAddNewLineAtEofWhitelist.includes(fileFormat);

const showJsonUnescapedSlashesWhitelist = [FileFormat.json, FileFormat.jsonStructured, FileFormat.arb];
export const isJsonUnescapedSlashesHidden = (fileFormat: FileFormat) =>
    !showJsonUnescapedSlashesWhitelist.includes(fileFormat);

export const showYamlIncludeRootWhitelist = [FileFormat.yaml, FileFormat.yamlRuby];
export const isYamlIncludeRootHidden = (fileFormat: FileFormat, switchCompact: boolean) =>
    !showYamlIncludeRootWhitelist.includes(fileFormat) || switchCompact;

const isDisableReferencesHidden = (fileFormat: FileFormat) => fileFormat === FileFormat.srt;

const getHiddenCheckboxes = (
    fileFormat: FileFormat,
    switchCompact: boolean,
    isNoLanguageFoldersSwitchHidden: boolean,
): Record<keyof Value, boolean> => ({
    switchCompact: isSwitchCompactHidden(fileFormat),
    switchIncludeDescription: isIncludeDescriptionHidden(fileFormat, switchCompact),
    switchIncludeComments: isIncludeCommentsHidden(fileFormat, switchCompact),
    switchYamlIncludeRoot: isYamlIncludeRootHidden(fileFormat, switchCompact),
    jsonUnescapedSlashes: isJsonUnescapedSlashesHidden(fileFormat),
    addNewlineEof: isAddNewLineAtEofHidden(fileFormat),
    replaceLineBreaks: isReplaceLineBreaksHidden(fileFormat),
    switchNoLanguageFolders: isNoLanguageFoldersSwitchHidden,
    switchDisableReferences: isDisableReferencesHidden(fileFormat),
});

export default getHiddenCheckboxes;
